import React from 'react'
import ReactDOM from 'react-dom'
import App from '../src/App'
import { Provider } from 'react-redux'
import store from '../src/store'

document.addEventListener('DOMContentLoaded', () => {
  const mountNode = document.getElementById('root') || document.getElementById('app')
  if (mountNode) {
    ReactDOM.render(
      React.createElement(Provider, { store }, React.createElement(App)),
      mountNode
    )
  }
})
